import { render, staticRenderFns } from "./UpdateCustomerProductContractsPopUp.vue?vue&type=template&id=40d2dfb4&scoped=true&"
import script from "./UpdateCustomerProductContractsPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerProductContractsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerProductContractsPopUp.vue?vue&type=style&index=0&id=40d2dfb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2dfb4",
  null
  
)

export default component.exports